import { RootState } from "@/infrastructure/rootState";
import { slugify } from "@/utils/string";

export const cacheKeys = ({ app }: RootState) => app.cache;

export const userDocName = ({ app }: RootState) => slugify(app.userInfo.username);
export const userWatchlist = ({ app }: RootState) => app.userInfo.watchlist;
export const userAlertLimit = ({ app }: RootState) => app.userInfo.priceAlert;

export const userLastVistWL = ({ app }: RootState) => app.userInfo.userPreference.lastVisitedWatchlist;
export const userPreference = ({ app }: RootState) => app.userInfo.userPreference;

export const userId = ({ app }: RootState) => app.userInfo.userId;
export const username = ({ app }: RootState) => app.userInfo.username;
export const isSuperuser = ({ app }: RootState) => app.userInfo.isSuperuser;
